import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createTemplatePortal = async (data) => {
  const res = await axiosInstance.post("/syllabus-portal/template/create", data);
  return res.data;
};

export const getAllTemplatesPortal = async (filters = {}) => {
  const res = await axiosInstance.get("/syllabus-portal/template/all", { params: filters });
  return res.data;
};

export const getTemplateByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/syllabus-portal/template/${id}`);
  return res.data;
};

export const updateTemplatePortal = async (id, data) => {
  const res = await axiosInstance.put(`/syllabus-portal/template/update/${id}`, data);
  return res.data;
};

export const updateChaptersPortal = async (id, chapters) => {
  const res = await axiosInstance.put(`/syllabus-portal/template/chapters/${id}`, { chapters });
  return res.data;
};

export const deleteTemplatePortal = async (id) => {
  const res = await axiosInstance.delete(`/syllabus-portal/template/delete/${id}`);
  return res.data;
};

export const getProgressOverviewPortal = async (templateId) => {
  const res = await axiosInstance.get(`/syllabus-portal/progress/overview/${templateId}`);
  return res.data;
};

export const getSectionProgressPortal = async (sectionId, subjectId = "") => {
  const res = await axiosInstance.get(`/syllabus-portal/progress/${sectionId}`, {
    params: subjectId ? { subjectId } : {},
  });
  return res.data;
};

export const getMySyllabus = async (sectionId, subjectId) => {
  const res = await axiosInstance.get("/syllabus-portal/my-syllabus", {
    params: { sectionId, subjectId },
  });
  return res.data;
};

export const toggleTopicStatus = async (data) => {
  const res = await axiosInstance.post("/syllabus-portal/progress/toggle", data);
  return res.data;
};